export default {
  title: 'Collection de produit',
  noResults: 'Aucune collection trouvées',
  createNew: 'Créer une collection',
  edit: 'Editer une collection'
}
